import { render } from "./inputValidateText.vue?vue&type=template&id=68012885&lang=pug"
import script from "./inputValidateText.vue?vue&type=script&lang=js"
export * from "./inputValidateText.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__